// ContactUsPage.jsx
import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  Paper,
  Stack,
} from '@mui/material';
import { LocationOn, Phone, Email } from '@mui/icons-material';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // TODO: integrate with backend or email API (e.g. EmailJS, Firebase Function)
  };

  return (
    <Box component="main">
      {/* Hero Section */}
      <Box
        sx={{
          py: 20,
          textAlign: 'center',
          color: 'black',
          background: 'url(/images/contact-hero.jpg) center/cover no-repeat',
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="h3" gutterBottom>
            Contáctanos
          </Typography>
          <Typography variant="h6">
            ¿Tienes alguna duda o pregunta? Llena los siguientes datos para comentarnos tus opiniones sobre algunos de nuestros servicios.
            (redes sociales y numero de WhatsApp sin confirmar)
            Información de contacto
          </Typography>
        </Container>
      </Box>

      {/* Contact Info Section */}
      <Container sx={{ py: 8 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Stack alignItems="center" spacing={1}>
              <LocationOn color="primary" sx={{ fontSize: 40 }} />
              <Typography variant="h6">Dirección</Typography>
              <Typography color="text.secondary" align="center">
                Camino a Nextetelco 64B, San Antonio, 72660 Santa María Zacatepec, Pue.
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack alignItems="center" spacing={1}>
              <Phone color="primary" sx={{ fontSize: 40 }} />
              <Typography variant="h6">Teléfono</Typography>
              <Typography color="text.secondary" align="center">
                +52 55 1234 5678
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack alignItems="center" spacing={1}>
              <Email color="primary" sx={{ fontSize: 40 }} />
              <Typography variant="h6">Correo</Typography>
              <Typography color="text.secondary" align="center">
                contacto@cardexmedico.com
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      {/* Contact Form Section */}
      <Box sx={{ backgroundColor: 'grey.100', py: 8 }}>
        <Container maxWidth="md">
          <Typography variant="h4" align="center" gutterBottom>
            Envíanos un mensaje
          </Typography>
          <Paper sx={{ p: 4, mt: 4 }}>
            <Box component="form" onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Correo electrónico"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Telefono"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Nombre"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Asunto"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Mensaje"
                    name="message"
                    multiline
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                  <Button type="submit" variant="contained" size="large">
                    Enviar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </Box>

      {/* Map Section */}
      <Box sx={{ py: 8 }}>
        <Container maxWidth="md">
          <Typography variant="h4" align="center" gutterBottom>
            Nuestra ubicación
          </Typography>
          <Box
            component="iframe"
            src="https://www.google.com/maps?q=Camino+a+Nextetelco+64B%2C+San+Antonio%2C+72660+Santa+Mar%C3%ADa+Zacatepec%2C+Pue.&hl=es-419&gl=mx&output=embed"
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></Box>
        </Container>
      </Box>
    </Box>
  );
};

export default ContactUs;
